import NewAccountContent from './index.content'
import EditAccountProvider from './index.provider'

const EditAccountScreen: React.FC = () => {
  return (
    <EditAccountProvider>
      <NewAccountContent />
    </EditAccountProvider>
  )
}

export default EditAccountScreen
